import { useCallback, useState } from "react";

import { onboardingAgentTrackingService } from "../../onboardingAgentTrackingService";

type UseOnboardingAgentThumbsDownFeedbackParams = {
    readonly messageIndex: number;
    readonly isActive: boolean;
    readonly threadId?: string;
    readonly onActiveChange: (active: boolean) => void;
    readonly onClearLike: () => void;
};

export const useOnboardingAgentThumbsDownFeedback = ({
    messageIndex,
    isActive,
    threadId,
    onActiveChange,
    onClearLike,
}: UseOnboardingAgentThumbsDownFeedbackParams) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [comment, setComment] = useState("");

    const dismissFeedbackModal = useCallback((): void => {
        setModalOpen(false);
    }, []);

    const handleThumbClick = useCallback((): void => {
        if (!isActive) {
            onActiveChange(true);
            onClearLike();
            setComment("");
            onboardingAgentTrackingService.trackFeedback({ type: "dislike", messageIndex, threadId });
            setModalOpen(true);

            return;
        }

        onActiveChange(false);
        setComment("");
        dismissFeedbackModal();
    }, [dismissFeedbackModal, isActive, messageIndex, onActiveChange, onClearLike, threadId]);

    const handleSubmitFeedback = useCallback((): void => {
        onboardingAgentTrackingService.trackFeedback({
            type: "dislike_submit",
            messageIndex,
            comment: comment.trim(),
            threadId,
        });
        setComment("");
        dismissFeedbackModal();
    }, [dismissFeedbackModal, comment, messageIndex, threadId]);

    const handleCommentChange = useCallback((value: string): void => {
        setComment(value);
    }, []);

    return {
        isModalOpen,
        comment,
        handleThumbClick,
        handleSubmitFeedback,
        handleCommentChange,
        dismissFeedbackModal,
    };
};
